<template>
  <div class="tw-flex tw-items-center tw-gap-2 tw-flex-wrap tw-text-xs">
    <span class="tw-font-semibold tw-text-gray-400 tw-uppercase tw-tracking-wider">Productie van</span>
    <button
      type="button"
      class="tw-rounded-full tw-border tw-px-3 tw-py-1 tw-transition-colors"
      :class="optionClass(value === ADDRESS)"
      :title="kind === 'cvz' ? 'Alle meters van de CVZ samen, ook op de aparte CVZ-adressen' : 'Alle meters op dit adres samen, elk in de periode dat hij er telde'"
      @click="$emit('input', ADDRESS)"
    >Hele adres<span v-if="devices.length > 1" class="tw-text-gray-400"> ({{ devices.length }})</span></button>
    <button
      v-for="device in devices"
      :key="device.serial_number"
      type="button"
      class="tw-rounded-full tw-border tw-px-3 tw-py-1 tw-font-mono tw-transition-colors"
      :class="[optionClass(value === device.serial_number), { 'tw-opacity-60': !device.current }]"
      :title="device.current ? 'Alleen deze meter' : 'Alleen deze (vervangen) meter'"
      @click="$emit('input', device.serial_number)"
    >
      {{ device.serial_number }}<span v-if="kind === 'cvz' && device.house_number" class="tw-font-sans tw-text-gray-400"> {{ device.house_number }}</span>
    </button>

    <!-- The whole address: the sum, or every meter as its own series in the same chart -->
    <span
      v-if="value === ADDRESS"
      class="tw-ml-auto tw-inline-flex tw-rounded-full tw-border tw-border-gray-200 tw-overflow-hidden"
    >
      <button
        type="button"
        class="tw-px-3 tw-py-1 tw-transition-colors"
        :class="!split ? 'tw-bg-blue-50 tw-text-blue-700' : 'tw-bg-white tw-text-gray-600 hover:tw-text-blue-600'"
        title="Eén reeks: alle meters opgeteld"
        @click="$emit('update:split', false)"
      >Opgeteld</button>
      <button
        type="button"
        class="tw-px-3 tw-py-1 tw-border-l tw-border-gray-200 tw-transition-colors"
        :class="split ? 'tw-bg-blue-50 tw-text-blue-700' : 'tw-bg-white tw-text-gray-600 hover:tw-text-blue-600'"
        title="Elke meter als eigen reeks in dezelfde grafiek"
        @click="$emit('update:split', true)"
      >Per meter</button>
    </span>
  </div>
</template>

<script setup>
// What the production charts show: the whole address (default) or one meter, and for the whole address
// the sum or every meter separately. Only rendered when the address has more than one meter.
// v-model: 'address' or a serial number; split.sync: per meter instead of the sum.
const ADDRESS = 'address'

defineProps({
  value: { type: String, required: true },
  devices: { type: Array, required: true },
  kind: { type: String, default: 'regular' },
  split: { type: Boolean, default: false },
})

defineEmits(['input', 'update:split'])

const optionClass = (active) => active
  ? 'tw-border-blue-400 tw-bg-blue-50 tw-text-blue-700'
  : 'tw-border-gray-200 tw-bg-white tw-text-gray-600 hover:tw-border-blue-400 hover:tw-text-blue-600'
</script>
